<template>
  <svg width="24"
       height="30"
       viewBox="0 0 56 73"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M39.7014 0H1.9053C0.853023 0 0 0.853023 0 2.50828V71.6279C0 72.0772 0.853023 72.9302 1.9053 72.9302H54.0947C55.147 72.9302 56 72.0772 56 71.6279V16.9016C56 15.9952 55.8789 15.7034 55.6653 15.4886L40.5114 0.334698C40.2966 0.121116 40.0048 0 39.7014 0Z"
          fill="#E9E9E0"/>
    <path d="M40.3716 0.196289V15.6275H55.8028L40.3716 0.196289Z"
          fill="#D9D7CA"/>
    <path d="M54.0947 72.9291H1.9053C0.853023 72.9291 0 72.0761 0 71.0238V50.7896H56V71.0238C56 72.0761 55.147 72.9291 54.0947 72.9291Z"
          fill="#007D87"/>
    <path d="M17.3403 23.4997C20.4731 23.4997 23.0127 20.9601 23.0127 17.8274C23.0127 14.6946 20.4731 12.155 17.3403 12.155C14.2076 12.155 11.668 14.6946 11.668 17.8274C11.668 20.9601 14.2076 23.4997 17.3403 23.4997Z"
          fill="url(#paint0_linear_35598_1870)"/>
    <path d="M4.8623 46.1894L5.37773 45.4579L14.5408 32.243C15.0562 31.4879 15.8808 31.0513 16.7742 31.0513C17.6676 31.0513 18.4923 31.4879 19.0077 32.2312L22.5011 37.2694L32.0078 24.5973C32.5347 23.9012 33.3364 23.5 34.184 23.5C35.0316 23.5 35.8448 23.9012 36.3602 24.5973L51.9374 45.3635L52.5101 46.1304"
          fill="#00CC99"/>
    <path d="M12.464 67.9302V56.3622H16.472C17.2987 56.3622 18.0373 56.5035 18.688 56.7862C19.344 57.0688 19.8587 57.4848 20.232 58.0342C20.6107 58.5835 20.8 59.2582 20.8 60.0582C20.8 60.8262 20.6267 61.4822 20.28 62.0262C19.9387 62.5648 19.4587 62.9782 18.84 63.2662C18.2267 63.5488 17.5147 63.6902 16.704 63.6902H14.208V67.9302H12.464ZM14.2 62.2902H16.656C17.392 62.2902 17.992 62.0795 18.456 61.6582C18.92 61.2315 19.152 60.6662 19.152 59.9622C19.152 59.2475 18.912 58.7008 18.432 58.3222C17.952 57.9382 17.3387 57.7462 16.592 57.7462H14.2V62.2902ZM30.258 56.3622H31.978V67.9302H30.442L24.426 59.1222V67.9302H22.714V56.3622H24.37L30.258 64.9862V56.3622ZM39.2695 68.0902C38.2402 68.0902 37.3522 67.8555 36.6055 67.3862C35.8588 66.9168 35.2828 66.2422 34.8775 65.3622C34.4775 64.4768 34.2775 63.4155 34.2775 62.1782C34.2775 60.9302 34.4828 59.8608 34.8935 58.9702C35.3095 58.0742 35.8988 57.3888 36.6615 56.9142C37.4242 56.4395 38.3202 56.2022 39.3495 56.2022C39.9628 56.2022 40.5308 56.3062 41.0535 56.5142C41.5815 56.7222 42.0455 57.0048 42.4455 57.3622C42.8508 57.7195 43.1708 58.1248 43.4055 58.5782C43.6402 59.0315 43.7735 59.5062 43.8055 60.0022H41.9815C41.9068 59.5915 41.7468 59.2128 41.5015 58.8662C41.2615 58.5142 40.9548 58.2315 40.5815 58.0182C40.2082 57.8048 39.7868 57.6982 39.3175 57.6982C38.6935 57.6982 38.1415 57.8528 37.6615 58.1622C37.1815 58.4715 36.8055 58.9542 36.5335 59.6102C36.2668 60.2608 36.1335 61.1035 36.1335 62.1382C36.1335 62.9435 36.2162 63.6288 36.3815 64.1942C36.5522 64.7595 36.7842 65.2155 37.0775 65.5622C37.3708 65.9088 37.7148 66.1622 38.1095 66.3222C38.5042 66.4768 38.9255 66.5542 39.3735 66.5542C39.8162 66.5542 40.2055 66.4768 40.5415 66.3222C40.8775 66.1675 41.1575 65.9675 41.3815 65.7222C41.6108 65.4768 41.7868 65.2128 41.9095 64.9302C42.0375 64.6422 42.1122 64.3648 42.1335 64.0982L42.1895 63.1622H39.4855V61.9302L43.9735 61.9462V67.9302H42.7335V66.2342C42.5308 66.5488 42.2775 66.8475 41.9735 67.1302C41.6695 67.4128 41.2962 67.6448 40.8535 67.8262C40.4108 68.0022 39.8828 68.0902 39.2695 68.0902Z"
          fill="white"/>
    <defs>
      <linearGradient id="paint0_linear_35598_1870"
                      x1="13.1477"
                      y1="21.8683"
                      x2="15.3819"
                      y2="12.0764"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#A58500"/>
        <stop offset="0.5028"
              stop-color="#FBC402"/>
        <stop offset="1"
              stop-color="#FFE9A4"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'PNGIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 18
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
